// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6e93c585","703":"8b43216a"}[chunkId] + ".chunk.js";
};